import classes from './ImageVideo.module.scss';

import Blob from '../UI/Blob/Blob';
import YouTube from 'react-youtube';
import Vimeo from '../UI/Vimeo/Vimeo';
import { useEffect, useState } from 'react';

function ImageVideo(props: any) {
  const [hasMarketingConsent, setHasMarketingConsent] = useState(false);
  const [hasCookiebot, setHasCookiebot] = useState(false);

  useEffect(() => {
    const updateMarketingConsent = () => {
      const cookiebot = (window as any).Cookiebot;
      setHasCookiebot(Boolean(cookiebot));
      setHasMarketingConsent(Boolean(cookiebot && cookiebot.consent && cookiebot.consent.marketing));
    };

    updateMarketingConsent();

    window.addEventListener('CookiebotOnConsentReady', updateMarketingConsent);
    window.addEventListener('CookiebotOnAccept', updateMarketingConsent);
    window.addEventListener('CookiebotOnDecline', updateMarketingConsent);

    return () => {
      window.removeEventListener('CookiebotOnConsentReady', updateMarketingConsent);
      window.removeEventListener('CookiebotOnAccept', updateMarketingConsent);
      window.removeEventListener('CookiebotOnDecline', updateMarketingConsent);
    };
  }, []);

  const openConsentDialog = () => {
    const cookiebot = (window as any).Cookiebot;

    if (cookiebot && cookiebot.renew) {
      cookiebot.renew();
    }
  };

  const videoPlay = (data: any) => {
    let title = '';

    if (data.target && data.target.getVideoData) {
      title = data.target.getVideoData().title;
    }

    const gtmObject: any = {
      'event': 'Video',
      'category': 'Video',
      'action': 'Start video',
      'label': title
    };

    if ((window as any).dataLayer) {
      (window as any).dataLayer.push(gtmObject);
    }
  }

  const video = hasMarketingConsent ?
    props.videoType === "Vimeo" ?
      <Vimeo className="embed-responsive-item" video={props.embedCode} onPlay={videoPlay} /> :
      <YouTube className="embed-responsive-item" videoId={props.embedCode} onPlay={videoPlay} /> :
    <div className={`${classes.ConsentPlaceholder} embed-responsive-item`}>
      <span>Om deze video te bekijken, moet je marketingcookies accepteren.</span>
      {
        hasCookiebot &&
        <button type="button" className={classes.ConsentLink} onClick={openConsentDialog}>
          Cookievoorkeuren aanpassen
        </button>
      }
    </div>;

  return (
    !props.displayOnTwoColumnPage ?
      <div id={props.linkId} className={classes.Wrapper}>
        <div className={classes.backPanel}></div>
        <div className="container position-relative">
          <Blob className={classes.blob} type='video'></Blob>
          <div className={classes.Content}>
            {
              props.upperIllustration &&
              <img className={classes.UpperIllustration} src={props.upperIllustration.umbracoFile} alt=""></img>
            }
            <div className="embed-responsive embed-responsive-16by9">
              {
                props.embedCode ?
                  video :
                  <img className="embed-responsive-item" src={props.imageUrl} alt={props.imageAlt || "Video-afbeelding"}></img>
              }
            </div>
            {props.text ? <div className={classes.Text}>{props.text}</div> : null}
            {
              props.bottomIllustration &&
              <img className={classes.BottomIllustration} src={props.bottomIllustration.umbracoFile} alt=""></img>
            }
          </div>
        </div>
      </div> :
      <div id={props.linkId} className={classes.videoPanel}>
        <div className="embed-responsive embed-responsive-4by3">
          {
            props.embedCode ?
              video :
              <img className="embed-responsive-item" src={props.image.umbracoFile} alt={props.imageAlt || "Video-afbeelding"}></img>
          }
        </div>
        {
          props.bottomIllustration &&
          <img className={classes.smallVideoIllustration} src={props.bottomIllustration.umbracoFile} alt=""></img>
        }
      </div>
  )
}

export default ImageVideo;
